import {CatalogOffer} from 'epic-graphql-types';

export enum SearchActionTypes {
    SET_SEARCH_TEXT = 'SET_SEARCH_TEXT',
    FETCH_SEARCH_AUTOCOMPLETE = 'FETCH_SEARCH_AUTOCOMPLETE',
    FETCH_SEARCH_AUTOCOMPLETE_SUCCESS = 'FETCH_SEARCH_AUTOCOMPLETE_SUCCESS',
    FETCH_SEARCH_AUTOCOMPLETE_FAILED = 'FETCH_SEARCH_AUTOCOMPLETE_FAILED',
    SEARCH = 'SEARCH',
    SEARCH_SUCCESS = 'SEARCH_SUCCESS',
    SEARCH_FAILURE = 'SEARCH_FAILURE'
}

interface SearchAction<Payload> {
    type: SearchActionTypes;
    payload: Payload;
}

export type ExecuteSearchAction = SearchAction<{query: string}>;

export const setSearchText = (query: string): ExecuteSearchAction => {
    return {type: SearchActionTypes.SET_SEARCH_TEXT, payload: {query}};
};

export const fetchAutocompleteSuccess = (
    query,
    offers: CatalogOffer[]
): SearchAction<{query: string; offers: CatalogOffer[]}> => {
    return {
        type: SearchActionTypes.FETCH_SEARCH_AUTOCOMPLETE_SUCCESS,
        payload: {query, offers}
    };
};

export const fetchSearchResults = (query: string): ExecuteSearchAction => {
    return {
        type: SearchActionTypes.SEARCH,
        payload: {query}
    };
};

export const fetchSearchResultsSuccess = (
    query: string,
    offers: CatalogOffer[]
): SearchAction<{query: string; offers: CatalogOffer[]}> => {
    return {
        type: SearchActionTypes.SEARCH_SUCCESS,
        payload: {query, offers}
    };
};

export const fetchSearchResultsFailure = () => ({
    type: SearchActionTypes.SEARCH_FAILURE,
    payload: {}
});
